import { useEffect, useState } from 'react';
import { dashboardApi } from '@/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { StatCard } from '@/components/ui/StatCard';
import { formatCurrency } from '@/utils/format';
import type { MasterAdminDashboardStats } from '@/types/dashboard';
import {
  Line,
  LineChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { showApiError } from '@/utils/apiError';

export function AnalyticsPage() {
  const [stats, setStats] = useState<MasterAdminDashboardStats | null>(null);

  useEffect(() => {
    dashboardApi.masterStats().then(setStats).catch((err) => showApiError(err, 'Failed to load analytics'));
  }, []);

  const trend = stats
    ? [
        { period: 'Today', sales: Number(stats.todaySalesPlatform) },
        { period: 'Month', sales: Number(stats.monthSalesPlatform) },
      ]
    : [];

  return (
    <div>
      <PageHeader title="Platform Analytics" breadcrumbs={[{ label: 'Master', to: '/master' }, { label: 'Analytics' }]} />
      <div className="grid gap-4 sm:grid-cols-3">
        <StatCard title="Platform Invoices Today" value={stats?.todayInvoicesPlatform ?? '—'} />
        <StatCard title="Sales Today" value={stats ? formatCurrency(stats.todaySalesPlatform) : '—'} />
        <StatCard title="Sales This Month" value={stats ? formatCurrency(stats.monthSalesPlatform) : '—'} />
      </div>
      <div className="card mt-6 p-4">
        <h3 className="mb-4 font-semibold">Sales trend</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={trend}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="period" />
            <YAxis />
            <Tooltip formatter={(v: number) => formatCurrency(v)} />
            <Line type="monotone" dataKey="sales" stroke="#2563eb" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
